//TODO :: 추후 해외상품을 고려한 단위 필요
export const HEADER_LIST = [
	'선택',
	'수정',
	'도매사',
	'상품관리코드',
	'상품명',
	'판매상태',
	'재고',
	'도매가격(원)',
	'소매가격(원)',
	'배송비(원)',
	'옵션',
	'상품등록일',
	'최종수정일',
];

